import React from 'react';
import ReactDOM from 'react-dom';

class RenderInBody extends React.Component {
  componentDidMount() {
    this._containerDiv = document.createElement('div');
    this._containerDiv.className = 'hx';
    document.body.appendChild(this._containerDiv);

    ReactDOM.render(this.props.children, this._containerDiv);
  }

  componentDidUpdate() {
    ReactDOM.render(this.props.children, this._containerDiv);
  }

  componentWillUnmount() {
    document.body.removeChild(this._containerDiv);
  }

  render() {
    return null;
  }
}

export default RenderInBody;